import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { KpiService } from "../../kpi/kpi.service";
import {
  View,
  Group,
  EfficacyCriteria,
  student,
} from "../../store/students/state";

import * as _ from "lodash";

@Component({
  selector: "app-add-students-to-group-modal",
  templateUrl: "./add-students-to-group-modal.component.html",
  styleUrls: ["./add-students-to-group-modal.component.scss"],
})
export class AddStudentsToGroupModalComponent {
  error: string;
  hasChangesToSave: boolean;
  selectedGroup;
  groupsForDropdown;
  metricRemovedFromDashboardText = "metric no longer on dashboard";
  action: string;
  students: Array<student>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private kpiService: KpiService,
    public dialogRef: MatDialogRef<AddStudentsToGroupModalComponent>,
    public dialog: MatDialog
  ) {
    this.action = this.data.action;
    this.students = this.data.students;

    if (this.data.selectedGroup && !this.data.selectedGroup.isSharedWithMe) {
      this.selectedGroup = this.data.selectedGroup;
    } else {
      this.groupsForDropdown =
        this.data.groups && this.data.groups.length > 0
          ? _.orderBy(
              this.data.groups,
              [
                (group) => group["isSharedWithMe"],
                (group) =>
                  group["name"] ? group["name"].toLowerCase() : group["name"],
              ],
              ["asc", "asc"]
            )
          : [];
    }
  }

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close();
  }

  getColName(id) {
    let currentCol = _.find(this.data.columns, ["id", Number(id)]);
    if (currentCol) {
      return currentCol["title"];
    } else {
      return this.metricRemovedFromDashboardText;
    }
  }

  getColumn(id) {
    let currentCol = _.find(this.data.columns, ["id", Number(id)]);
    return currentCol;
  }

  handleSaveError(err) {
    this.error = err;
    console.error(err);
  }

  addToGroup() {
    this.error = null;
    this.kpiService
      .addStudentsToGroup(this.selectedGroup, this.data.students)
      .subscribe(
        (data: Group) => {
          let alreadyAdded = 0;
          this.data.students.forEach((studentID) => {
            if (this.selectedGroup.studentsInGroup.includes(studentID)) {
              alreadyAdded++;
            }
          });
          this.dialogRef.close({
            action: this.action,
            alreadyAdded: alreadyAdded,
            numberOfStudentsAdded: this.data.students.length - alreadyAdded,
            groupName: data.name,
            groupId: data.id,
            studentsInGroup: data.studentsInGroup,
          });
        },
        (err) => {
          this.handleSaveError(err);
        }
      );
  }

  removeFromGroup() {
    this.error = null;
    this.kpiService
      .removeStudentsFromGroup(this.selectedGroup, this.data.students)
      .subscribe(
        (data: Group) => {
          this.dialogRef.close({
            action: this.action,
            numberOfStudentsRemoved: this.data.students.length,
            groupName: data.name,
            groupId: data.id,
            studentsInGroup: data.studentsInGroup,
          });
        },
        (err) => {
          this.handleSaveError(err);
        }
      );
  }
}
